import { render, staticRenderFns } from "./houseSwiperImg.components.vue?vue&type=template&id=c7c25a7a&scoped=true"
import script from "./houseSwiperImg.components.vue?vue&type=script&lang=js"
export * from "./houseSwiperImg.components.vue?vue&type=script&lang=js"
import style0 from "./houseSwiperImg.components.vue?vue&type=style&index=0&id=c7c25a7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c25a7a",
  null
  
)

export default component.exports